const API = process.env.REACT_APP_EASYCONCIERGE_API;

const get = async (params) => {
  const r = await fetch(`${API}?${new URLSearchParams(params).toString()}`, { signal: AbortSignal.timeout(7000) });
  const d = await r.json().catch(() => ({ success: false }));
  return { httpStatus: r.status, ...d };
};

export const ecProperty = (id) => get({ action: "property", id });
export const ecMonth = (id, year, month) => get({ action: "availability", property_id: id, year, month });
export const ecCheck = (id, checkIn, checkOut) => get({ action: "check_availability", property_id: id, check_in: checkIn, check_out: checkOut });
export const ecQuote = (id, checkIn, checkOut, guests) => get({ action: "calculate", property_id: id, check_in: checkIn, check_out: checkOut, guests });
export const ecStatus = (params) => get({ action: "booking_status", ...params });

export const ecBook = async (body) => {
  const r = await fetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "book", ...body }),
  });
  const d = await r.json().catch(() => ({ success: false }));
  return { httpStatus: r.status, ...d };
};
